import {
  useAPIFetchPostApplication,
  useAPIFetchPutApplication,
} from '@marketplace/api';
import { TEditApplicationModalState } from 'src/pages/app-page/components/app-status/edit-app-modal/edit-app-form/edit-app-form.types';

const useAddEditApplicationModal = (
  applicationId: string,
  application: TEditApplicationModalState
) => {
  const {
    fetchPostApplication,
    loading: postLoading,
    data: { data: postData, errors: postDataErrors },
    error: postError,
  } = useAPIFetchPostApplication();

  const {
    fetchPutApplication,
    loading: putLoading,
    data: { data: putData, errors: putDataErrors },
    error: putError,
  } = useAPIFetchPutApplication(applicationId);

  const convertDataForForm = (data: TEditApplicationModalState) => ({
    categories: data?.categories?.map(
      (item: { name: string; id: string }) => item.id
    ),
    name: application?.name ?? '',
    products: application?.products?.map((item: any) => item.id),
    short_description: application?.short_description ?? '',
    facing: application?.facing ?? 'PROVIDER',
    intendedUsers: data?.intendedUsers?.filter((item:{name: string; id: string })=>item.name!="Unknown").map(
      (item: { name: string; id: string }) => item.id
    ),
    intendedPurposes: data?.intendedPurposes?.filter((item:{name: string; id: string })=>item.name!="Unknown").map(
      (item: { name: string; id: string }) => item.id
    ),
  });

  const hasApp = putData && !!Object.keys(putData).length;

  return {
    postLoading,
    postData,
    postDataErrors,
    putLoading,
    putData,
    putDataErrors,
    postError,
    putError,
    fetchPostApplication,
    fetchPutApplication,
    convertDataForForm,
    hasApp,
  };
};

export default useAddEditApplicationModal;
